export default () => {
  const data = {
    event_name: 'click',
    button_name: 'ordination_higher_cost',
    page_section: 'card_section',
    name_of_the_page_viewed: 'search_personal',
  };
  return data;
};
